import React from 'react';
import {Document, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import {OrderViewDTO} from "../../types/dto";
import {OrderFields} from "../../types/fields";

const styles = StyleSheet.create({
    table: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 16,
    },
    tableRow: {
        flexDirection: "row",
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        alignItems: 'stretch',
    },
    tableColHeaderSmall: {
        width: "15%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        backgroundColor: '#b3b3b3',
        justifyContent: 'center',
    },
    tableColHeader: {
        width: "20%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        backgroundColor: '#b3b3b3',
        justifyContent: 'center',
    },
    tableColHeaderMedium: {
        width: "25%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        backgroundColor: '#b3b3b3',
        justifyContent: 'center',
    },
    tableColHeaderBig: {
        width: "40%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        backgroundColor: '#b3b3b3',
        justifyContent: 'center',
    },
    tableColSmall: {
        width: "15%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        justifyContent: 'center',
    },
    tableCol: {
        width: "20%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        justifyContent: 'center',
    },
    tableColMedium: {
        width: "25%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        justifyContent: 'center',
    },
    tableColBig: {
        width: "40%",
        borderStyle: "solid",
        borderColor: '#000',
        borderBottomColor: '#000',
        borderBottomWidth: 1,
        justifyContent: 'center',
    },
    tableCellHeader: {
        margin: "auto",
        marginTop: 5,
        fontSize: 12,
        fontWeight: 'bold',
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
    },
});

interface OrdersPDFTableProps {
    orderList: OrderViewDTO[]
}

function OrdersPDFTable({orderList}: OrdersPDFTableProps) {
    return (
        <Document>
            <Page size="A4">
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Direccion</Text>
                        </View>
                        <View style={styles.tableColHeaderSmall}>
                            <Text style={styles.tableCellHeader}>Destinatario</Text>
                        </View>

                        <View style={styles.tableColHeaderBig}>
                            <Text style={styles.tableCellHeader}>Mercaderia</Text>
                        </View>
                        <View style={styles.tableColHeaderMedium}>
                            <Text style={styles.tableCellHeader}>Observaciones / Materiales devueltos</Text>
                        </View>
                    </View>
                    {orderList.map((order, index) => (
                        <View key={index} style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{order[OrderFields.Address]}</Text>
                            </View>
                            <View style={styles.tableColSmall}>
                                <Text style={styles.tableCell}>{order[OrderFields.Receiver]}</Text>
                            </View>
                            <View style={styles.tableColBig}>
                                <Text style={styles.tableCell}>{order[OrderFields.Items]}</Text>
                            </View>
                            <View style={styles.tableColMedium}>
                                <Text style={styles.tableCell}>{order[OrderFields.Observations]}</Text>
                            </View>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
}

export default OrdersPDFTable;